module.exports = __webpack_public_path__ + "static/media/leaves.67896286.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/board/leaves.png
// module id = 66
// module chunks = 0